import React, { useContext, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { UserContext } from '../../context/UserContext';

function TutorProfileScreen() {
    const navigate = useNavigate();
    const [formFields, setFormFields] = useState({mode: '', value: '', private_mode: '', private_value: ''});
    const { setTostMessage } = useContext(TostMessageContext);
    const [cookies, setCookie, removeCookie] = useCookies();
    const {setUserProfile, userProfile, logOutFunction, reloadUser} = useContext(UserContext);
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const submit = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("tutor_id", location.state.tutor_id);
        formData.append("mode", formFields.mode);
        formData.append("value", formFields.value);
        formData.append("private_mode", formFields.private_mode);
        formData.append("private_value", formFields.private_value);

        try {
            const response = await axios.post(base_url + '/profile/update-tutor-settings.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    main_id: cookies?.userProfile?.main_id,
                    sub_id: cookies?.userProfile?.sub_id
                },
            });
            if (response.data.code == 403) {
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
                logOutFunction()
            }
            if (response.data.status) {
                setLoading(false);
                setTostMessage({
                    messageType: "success",
                    message: response.data.response,
                });
                setFormFields({mode: '', value: '', private_mode: '', private_value: ''});
                navigate('/all-tutors')
            } else {
                setLoading(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='flex flex-row justify-between'>
                    <div className="w-full px-10 py-[4rem] bg-[#FAFAFA] rounded-lg">
                        <h1 className="text-2xl font-bold text-gray-800 mb-6">Profile Settings</h1>
                        <div className="flex inline-flex flex-wrap w-full justify-between">
                            <div className='w-[48%] my-5 flex flex-col'>
                                <h3 className="text-xl font-semibold mb-4">Earning Mode (Group Classes)</h3>
                                <div className="space-y-4">
                                    <select className='w-full p-3 border rounded-md'
                                        onChange={(e) => setFormFields({...formFields, mode: e.target.value})}
                                    >
                                        <option value={''}>Select mode</option>
                                        <option value={'PERCENTAGE'}>Percentage class amount</option>
                                        <option value={'FIXED_AMOUNT'}>Fixed amount per student per class $</option>
                                    </select>
                                    <input
                                        type="text"
                                        placeholder="Commision Value"
                                        className="w-full p-3 border rounded-md"
                                        onChange={(e) => setFormFields({...formFields, value: e.target.value})}
                                    />
                                </div>
                            </div>

                            <div className='w-[48%] my-5 flex flex-col'>
                                <h3 className="text-xl font-semibold mb-4">Earning Mode (Private Classes)</h3>
                                <div className="space-y-4">
                                    <select className='w-full p-3 border rounded-md'
                                        onChange={(e) => setFormFields({...formFields, private_mode: e.target.value})}
                                    >
                                        <option value={''}>Select mode</option>
                                        <option value={'PERCENTAGE'}>Percentage class amount</option>
                                        <option value={'FIXED_AMOUNT'}>Fixed amount per student per class $</option>
                                    </select>
                                    <input
                                        type="text"
                                        placeholder="Commision Value"
                                        className="w-full p-3 border rounded-md"
                                        onChange={(e) => setFormFields({...formFields, private_value: e.target.value})}
                                    />
                                </div>
                            </div>
                            
                            <div className='w-full mt-3 flex justify-end'>
                                <ButtonSmall onPress={() => submit()} label={'Save'} loading={loading} />
                            </div>
                        </div>
                        </div>
                </div>
            </main>
        </div>
    </div>
  );
}

export default TutorProfileScreen;
